import { gql } from '@apollo/client';

export const SchemaTagDiffFragment = gql`
  fragment SchemaTagDiffFragment on SchemaTag {
    id
    publishedAt
    diffToPrevious {
      tag
      changes {
        code
        parentNode {
          name
        }
        childNode {
          name
          printedType
        }
        argNode {
          name
        }
      }
    }
  }
`;
